import React from 'react';
import moment from 'moment';
import { Row, Col } from 'antd';
import { IncentiveRatesView } from '@scheduling/components';
import { Icon, Text, Title } from '@common/components';
import { UnitRateType } from '@scheduling/graphql';
import {
  toHumanDateTimeWithTZ,
  toUSFormat,
} from 'works/legacy/lib/date-helper';

export function IncentiveRatesViewDrawerUnitRatesRow({
  unitRates,
}: {
  unitRates: UnitRateType;
}) {
  const { effectiveDate, endDate, createdAt, updatedAt, createdBy } = unitRates;

  const startDateEqualsEndDate = moment(effectiveDate).isSame(endDate);
  const adjustedEndDate = startDateEqualsEndDate
    ? moment(endDate).endOf('day')
    : moment(endDate).subtract(1, 'days').endOf('day');
  const adjustedEffectiveDate = moment(effectiveDate).startOf('day');

  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <Row gutter={[0, 8]}>
          <Col span={5}>
            <Title size="h3">
              {toUSFormat(adjustedEffectiveDate || updatedAt || createdAt)}
              <span style={{ paddingLeft: 8, marginRight: 2 }}>
                <Icon icon="sun" color="harvestGold" size="lg" />
              </span>
            </Title>
          </Col>
          {endDate && (
            <Col span={19}>
              <Title size="h3">
                {`- ${toUSFormat(adjustedEndDate)}`}
                <span style={{ paddingLeft: 8 }}>
                  <Icon icon="moon" color="skyRegular" size="lg" />
                </span>
              </Title>
            </Col>
          )}
        </Row>
        <Row gutter={[0, 8]}>
          <Col span={24}>
            <IncentiveRatesView.Dynamic rates={unitRates} />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <IncentiveRatesView.Variable rates={unitRates} />
      </Col>
      {createdBy && (
        <Col span={24}>
          <Text className="d-block">
            {createdBy.name} made these changes on{' '}
            {toHumanDateTimeWithTZ(createdAt)}.
          </Text>
        </Col>
      )}
    </Row>
  );
}
